import { Pipe, PipeTransform } from '@angular/core';
import { SavedSearchNS } from '../../../misc/saved-searches/models/saved-search.models';
@Pipe({ name: 'workflowActiveModuleActions', pure: false })
export class WorkflowActiveModuleActionsPipe implements PipeTransform {

    transform(actions: Array<any>, addedRules:  SavedSearchNS.IRuleList[], parentModuleId: number): any {
        if (actions && actions.length && addedRules?.length) {
            const transactionRule = addedRules.find(rule=> rule?.filter?.field?.toLowerCase()=='trans_transactiontype');
            let actionList: any[] = [];
            if(transactionRule && transactionRule?.operator?.name=='HasValue'){
                actionList = actions.filter(a=> a.parentModuleId==parentModuleId);
                return actionList?.length>0 ? actionList : null;
            }else if(transactionRule && transactionRule?.operator?.name=='IsEqualTo' && transactionRule?.value?.id){
                const addedTransactionModules = transactionRule.value?.id ? [transactionRule.value?.id] : [];
                actionList = actions.filter(a=> addedTransactionModules.includes(a.transactionId));
            }else if(!transactionRule){
                const objectIds = addedRules
                .map(rule => rule?.objectId)
                .filter(id => id != null && id !== parentModuleId);
                actionList = actions.filter(a=> objectIds.includes(a.objectId));
            }

            if(actionList?.length>0){
                const parentActionModule = actions.filter(a=> a.objectId==parentModuleId);
                return [...parentActionModule,...actionList];
            }else{
                return null;
            }
        } else {
            return actions;
        }
    }

}